const POINT_KEY_SEPARATOR = ":";

export function joinPointKey(...parts: string[]): string {
  return parts.join(POINT_KEY_SEPARATOR);
}

export function splitPointKey(key: string): string[] {
  return key.split(POINT_KEY_SEPARATOR);
}
